import { render, staticRenderFns } from "./Abierto.vue?vue&type=template&id=6ef38a3d&scoped=true&"
import script from "./Abierto.vue?vue&type=script&lang=js&"
export * from "./Abierto.vue?vue&type=script&lang=js&"
import style0 from "./Abierto.vue?vue&type=style&index=0&id=6ef38a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef38a3d",
  null
  
)

export default component.exports